import { createContext } from 'react';
import type { IProcessAction, Process } from '@common/interfaces';

export type ProcessContextValue = Readonly<{
    availableProcessActions?: IProcessAction[];
    expandedProcessActivityIds: string[];
    expandProcessActivity: (processActivityId: string) => void;
    process: Process;
    setExpandedProcessActivityIds: (expandedProcessActivityIds: string[]) => void;
}>;

export const ProcessContext = createContext<ProcessContextValue | null>(null);
